import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { makeHasRoleSelector } from '../selector/authenticationSelector';
import Roles from './roles';

/**
 * Returns true when the authenticated user has the `master` role.
 * Master Mode is a cross-tenant operational view — sidebar entry,
 * routes, and pages all gate on this hook.
 */
export const useIsMaster = (): boolean => {
    const selector = useMemo(() => makeHasRoleSelector(Roles.master()), []);
    return useSelector(selector);
};
